<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <!-- <navbar isBtn="bg-gradient-light" /> -->
      </div>
    </div>
  </div>
  <main class="main-content mt-0">
    <div
      class="page-header align-items-start min-vh-50 pt-5 pb-11 m-3 border-radius-lg"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/login-bg-new.png') + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }"
    >
      <span class="mask bg-gradient-dark opacity-6"></span>
    </div>
    <div class="container">
      <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
        <div class="col-xl-4 col-lg-5 col-md-7 mx-auto">
          <div class="card z-index-0">
            <div class="card-header text-center pt-4">
              <h5>Please Login</h5>
              <p class="text-sm font-weight-bold mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3"></p>
            </div>
            <div class="card-body">
              <!-- <form role="form"> -->
                <input type="text" class="form-control mb-3" placeholder="Username" v-model="username" v-on:keyup.enter="login()" required>
                <input type="password" class="form-control mb-3" placeholder="Password" v-model="password" v-on:keyup.enter="login()" required>
                <div class="text-end">
                  <a href="javascript:;" class="text-xs text-secondary" @click="openForgotPassword()">Lupa Password?</a>
                </div>
                <div class="text-center">
                  <button type="primary" class="my-4 btn btn-primary btn-outline-dark" @click="login()" :disabled="onLoading">
                      <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
                      <span v-else>
                          <span>Login</span>
                      </span>
                  </button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <app-footer />

  <!-- =======  MODAL LUPA PASSWORD ======= -->
  <div class="container">
    <vue-final-modal v-model="formForgot.show" classes="modal-container" content-class="modal-content">
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">Lupa Password</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formForgot.show = false"></i>
        </div>
      </div><hr>
      <div class="modal__content container">
        <template v-if="formForgot.step === 0">
          <p class="text-sm text-secondary">Masukkan username kamu. Kode OTP akan dikirim ke email yang terdaftar pada akun.</p>
          <label class="form-control-label">Username</label>
          <input type="text" class="form-control" v-model="formForgot.username" v-on:keyup.enter="requestOtp()">
        </template>
        <template v-else>
          <p class="text-sm text-secondary">Kode OTP telah dikirim ke <strong>{{ formForgot.maskedEmail }}</strong>. Berlaku 10 menit.</p>
          <label class="form-control-label">Kode OTP</label>
          <input type="text" class="form-control" maxlength="6" v-model="formForgot.otp">
          <label class="form-control-label mt-3">Password Baru</label>
          <input type="password" class="form-control" placeholder="Minimal 6 karakter" v-model="formForgot.password">
          <label class="form-control-label mt-3">Konfirmasi Password</label>
          <input type="password" class="form-control" placeholder="Ulangi password baru" v-model="formForgot.confirmPassword">
          <p class="text-xs mt-2"><a href="javascript:;" @click="formForgot.step = 0">Ganti username / kirim ulang kode</a></p>
        </template>
      </div>
      <div class="row float-right mt-3">
        <div class="col-6"></div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="formForgot.show = false">Close</argon-button>
        </div>
        <div class="col-2">
          <argon-button v-if="formForgot.step === 0" variant="gradient" color="success" size="sm" width="1" :disabled="formForgot.loading" @click="requestOtp()">Kirim OTP</argon-button>
          <argon-button v-else variant="gradient" color="success" size="sm" width="1" :disabled="formForgot.loading" @click="resetPassword()">Reset</argon-button>
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>
<script>
// import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
// const body = document.getElementsByTagName("body")[0];
import config from '@/configs/config';
import axios from 'axios';
import Api from '@/helpers/api';
import akun from '@/services/akun.service';
import forgotPassword from '@/services/forgotPassword.service';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { VueFinalModal } from 'vue-final-modal';
import ArgonButton from "@/components/ArgonButton.vue";

export default {
  components: {
    // Navbar,
    AppFooter,
    VueFinalModal,
    ArgonButton,
  },
  created() {
    // this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar  = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter  = false;
    // body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    // this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar  = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter  = true;
    // body.classList.add("bg-gray-100");
  },
  data() {
    return {
      username: '',
      password: '',
      onLoading: false,
      formForgot: {
        show: false,
        step: 0,
        username: '',
        otp: '',
        password: '',
        confirmPassword: '',
        maskedEmail: '',
        loading: false,
      },
    };
  },
  methods: {
    openForgotPassword() {
      this.formForgot = {
        show: true,
        step: 0,
        username: this.username || '',
        otp: '',
        password: '',
        confirmPassword: '',
        maskedEmail: '',
        loading: false,
      };
    },
    requestOtp() {
      if (!this.formForgot.username) {
        return alert('Username wajib diisi')
      }
      let context = this;
      context.formForgot.loading = true;
      Api(context, forgotPassword.requestOtp(context.formForgot.username)).onSuccess(function(response) {
        context.formForgot.maskedEmail = response.data.data.email;
        context.formForgot.step = 1;
      }).onError(function(error) {
        context.notify(error.response?.data?.message || 'Gagal mengirim kode OTP', 'error')
      }).onFinish(function() {
        context.formForgot.loading = false;
      })
      .call()
    },
    resetPassword() {
      const f = this.formForgot;
      if (!f.otp || !f.password) {
        return alert('Kode OTP dan password baru wajib diisi')
      }
      if (f.password.length < 6) {
        return alert('Password minimal 6 karakter')
      }
      if (f.password !== f.confirmPassword) {
        return alert('Konfirmasi password tidak sama')
      }
      let context = this;
      context.formForgot.loading = true;
      Api(context, forgotPassword.reset(f.username, f.otp, f.password)).onSuccess(function() {
        context.notify('Password berhasil direset. Silakan login.', 'success')
        context.formForgot.show = false;
      }).onError(function(error) {
        context.notify(error.response?.data?.message || 'Gagal mereset password', 'error')
      }).onFinish(function() {
        context.formForgot.loading = false;
      })
      .call()
    },
    login() {             
      if (this.username && this.password) {
        var formData = new FormData()
        formData.append('username',  this.username)
        formData.append('password', this.password)

        axios.post(config.apiUrl +"auth/login", formData)
        .then(response => {
          localStorage.setItem('token', response.data.access_token)                                        
          localStorage.setItem('authenticated', true) 

            // ======== untuk menentukan admin ============
            let context = this;     
            context.onLoading = true;          
            Api(context, akun.indexProfile()).onSuccess(function(response) {
                var dataRole = response.data.data[0];
                // context.notifyVue('Selamat anda berhasil login '+dataRole.full_name, 'top', 'right', 'info')
                localStorage.setItem('role', dataRole.role)
                localStorage.setItem('username', dataRole.full_name)
                if (dataRole.role == 'Admin') {
                    context.$router.push('dashboard-default')
                }else{
                    context.$router.push('/detail-profile/'+dataRole.employee_id)
                }
            }).onError(function(error) {  
            })
            .call() 
            // ==============================================                                      
            context.onLoading = true;
        })
        .catch(err => {
         this.notify('Username atau Password Salah', 'error')
        })
      } else {
        this.notify('Error Username Password Required', 'error')
      }
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          autoClose: 2000,
        }); // ToastOptions
      }
    },
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 420px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>
